Drupal.behaviors.mainMenu = {
  attach(context) {
    const body = context.querySelector('body');
    const toggleExpandClose = context.querySelector('#toggle-expand-close');
    const toggleExpandOpen = context.querySelector('#toggle-expand-fixed');
    const menu = context.querySelector('#main-nav');
    const nav = context.querySelector('.main-menu-nav');
    const breakpointLg = getComputedStyle(
      document.documentElement,
    ).getPropertyValue('--breakpoint-large');
    if (menu) {
      const expandMenu = menu.getElementsByClassName('expand-sub');
      const mainMenuLayer = nav.querySelector('.main-menu-layer');

      const closeMenuMobile = () => {
        if (window.innerWidth < breakpointLg) {
          if (body.classList.contains('main-menu-open')) {
            body.classList.remove('main-menu-open');
          }

          if (nav.classList.contains('main-menu-nav--open')) {
            nav.classList.remove('main-menu-nav--open');
          }

          if (toggleExpandClose.classList.contains('toggle-expand--open')) {
            toggleExpandClose.classList.remove('toggle-expand--open');
          }

          if (menu.classList.contains('main-nav--open')) {
            menu.classList.remove('main-nav--open');
          }
        }
      };

      // close menu in layer
      mainMenuLayer.addEventListener('click', (e) => {
        e.preventDefault();
        closeMenuMobile();
      });
      // Mobile Menu Show/Hide.
      toggleExpandOpen.addEventListener('click', (e) => {
        e.preventDefault();
        if (window.innerWidth < breakpointLg) {
          body.classList.add('main-menu-open');
          nav.classList.add('main-menu-nav--open');
          toggleExpandClose.classList.add('toggle-expand--open');
          menu.classList.add('main-nav--open');
        }
      });

      toggleExpandClose.addEventListener('click', (e) => {
        e.preventDefault();
        closeMenuMobile();
      });
      // Expose mobile sub menu on click.
      Array.from(expandMenu).forEach((item) => {
        item.addEventListener('click', (e) => {
          if (window.innerWidth < breakpointLg) {
            const menuItem = e.currentTarget;
            const subMenu = menuItem.parentElement.nextElementSibling;
            menuItem.classList.toggle('expand-sub--open');
            subMenu.classList.toggle('main-menu--sub-open');
          }
        });
      });
    }
  },
};
